import { useState } from 'react'
import { HelpCircle, X } from 'lucide-react'

export const PRINT_BOOK_SCOPE_HELP_SUMMARY =
  '학습자 교재 알림/신청 후보를 어떤 커리큘럼·코스에 매칭할지 정합니다.'

export const PRINT_BOOK_SCOPE_HELP_OPTIONS = [
  {
    label: '선택 안 함',
    description: '현재 백엔드에서는 전체와 동일하게 모든 커리큘럼/코스에 매칭됩니다.',
  },
  {
    label: '전체',
    description: '모든 커리큘럼과 코스의 학습자에게 매칭될 수 있습니다.',
  },
  {
    label: '커리큘럼',
    description: '입력한 커리큘럼 콘텐츠 ID와 같은 커리큘럼을 학습 중인 학생에게만 매칭됩니다.',
  },
  {
    label: '코스',
    description: '입력한 코스 콘텐츠 ID와 같은 코스를 학습 중인 학생에게만 매칭됩니다.',
  },
]

interface PrintBookScopeHelpProps {
  defaultOpen?: boolean
}

export function PrintBookScopeHelp({ defaultOpen = false }: PrintBookScopeHelpProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <>
      <span className="relative inline-flex group">
        <button
          type="button"
          aria-label="노출 범위 도움말"
          onClick={() => setOpen(true)}
          className="inline-flex h-5 w-5 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1"
        >
          <HelpCircle className="h-4 w-4" />
        </button>
        <span className="pointer-events-none absolute left-1/2 top-7 z-20 hidden w-72 -translate-x-1/2 rounded-lg border border-slate-200 bg-slate-900 px-3 py-2 text-xs font-normal leading-5 text-white shadow-lg group-hover:block group-focus-within:block">
          {PRINT_BOOK_SCOPE_HELP_SUMMARY}
        </span>
      </span>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/45 px-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="print-book-scope-help-title"
          onClick={() => setOpen(false)}
        >
          <div
            className="w-full max-w-lg rounded-xl bg-white shadow-2xl"
            onClick={event => event.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4">
              <div>
                <h3 id="print-book-scope-help-title" className="text-base font-semibold text-slate-900">
                  노출 범위
                </h3>
                <p className="mt-1 text-sm leading-6 text-slate-600">{PRINT_BOOK_SCOPE_HELP_SUMMARY}</p>
              </div>
              <button
                type="button"
                aria-label="닫기"
                onClick={() => setOpen(false)}
                className="rounded-lg p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-amber-500"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <div className="space-y-4 px-5 py-4">
              <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm leading-6 text-amber-900">
                실제 교재 안내/신청 후보로 보이려면 <strong>학습자 알림 노출</strong>이 켜져 있고{' '}
                <strong>교재 유형</strong>이 선택되어 있어야 합니다.
              </div>

              <dl className="divide-y divide-slate-100 rounded-lg border border-slate-200">
                {PRINT_BOOK_SCOPE_HELP_OPTIONS.map(option => (
                  <div key={option.label} className="grid grid-cols-[92px_1fr] gap-3 px-3 py-3">
                    <dt className="text-sm font-semibold text-slate-900">{option.label}</dt>
                    <dd className="text-sm leading-6 text-slate-600">{option.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
